import * as React from "react";
import {Fields, renderTextField} from "userform/utils";
import {TextField} from "components/common/inputFunctions";
import classnames from "classnames";

interface IProps {
    otpDigits: number;
    timer: number;
    onSubmit: (otp: number) => void;
    onSend: () => void;
    requestedOtp: boolean;
    error: string;
    newUI?: boolean;
}

interface IState {
    otp: number;
    otpError: string;
    showResend: boolean;
    showCountdown: boolean;
    time: number;
    sendText: string;
}

let timer = null;

export default class Otp extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
        this.state = {
            otpError: null,
            otp: null,
            showCountdown: false,
            showResend: false,
            time: props.timer,
            sendText: "Send",
        };
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleOnSendClick = this.handleOnSendClick.bind(this);
        this.handleOnSubmitClick = this.handleOnSubmitClick.bind(this);
    }

    public componentDidMount(): void {
        if (this.props.requestedOtp) {
            this.setState({showCountdown: true, showResend: false});
            this.startTimer();
        }
    }

    public validation() {
        let otpError = null;
        let status = true;
        if (!this.state.otp) {
            otpError = "Please enter OTP";
            status = false;
        }
        if (String(this.state.otp).length < this.props.otpDigits) {
            otpError = `Please enter ${this.props.otpDigits} digit OTP`;
            status = false;
        }
        return {
            otpError,
            status,
        };
    }

    public startTimer() {
        this.setState({
            showCountdown: true,
            time: this.props.timer,
        });
        timer = setInterval(() => {
            if (this.state.time !== 0) {
                this.setState({
                    time: this.state.time - 1,
                });
            } else {
                clearInterval(timer);
                this.setState({ showCountdown: false, showResend: true, otp: null, sendText: "Resend"});
            }
        }, 1000);
    }

    public clearTimer() {
        clearInterval(timer);
    }

    public handleOnSendClick() {
        this.props.onSend();
        this.startTimer();
    }

    public handleOnSubmitClick() {
        const validationResult = this.validation();
        if (validationResult.status) {
            this.props.onSubmit(this.state.otp);
            this.clearTimer();
        } else {
            this.setState({otpError: validationResult.otpError});
        }
    }

    public handleOnChange(fieldName, value) {
        if (fieldName === Fields.OTP && value.length <= 6) {
            this.setState({otp: Number(value)});
        }
    }

    public renderOtp() {
        return renderTextField("number",
            `Enter ${this.props.otpDigits} digit OTP`,
            this.state.otp,
            Fields.OTP,
            this.handleOnChange,
            "",
            "999999",
            String(this.props.otpDigits),
            this.state.otpError,
            false,
            "",
            true,
            false,
            false,
            true,
        );
    }

    public renderSendOtp() {
        const classname = classnames("btn btn-lg col-12 btn-custom py-3 mt-3",
            {"btn-secondary": this.state.showCountdown});
        return <div style={{width: "100%"}}>
            <button
                type="button"
                className="btn btn-sm col-12 center-block btn-custom py-3 btn-resendOtp"
                disabled={this.state.showCountdown}
                onClick={this.handleOnSendClick}>
                {this.state.showCountdown ? this.state.time : this.state.sendText}
            </button>
        </div>;
    }

    public renderSubmitOtp() {
        const allowSubmit = String(this.state.otp).length === this.props.otpDigits;
        return <div style={{width: "100%"}}>
            <button
                disabled={!allowSubmit}
                type="button"
                className={ allowSubmit ? "btn btn-sm col-12 center-block btn-custom py-3 btn-submit-otp" :
                    "btn btn-sm col-12 center-block btn-custom py-3"}
                onClick={this.handleOnSubmitClick}>
                Verify
            </button>
        </div>;
    }
    public newRenderOtp() {
        return(
            <TextField
                value={this.state.otp}
                placeholder="Enter OTP here"
                fieldName={Fields.OTP}
                type="number"
                onChange={this.handleOnChange}/>
        );
    }
    public render() {
        return <div>
            <form>
                {this.props.newUI ? this.newRenderOtp() : this.renderOtp()}
                {(this.props.error || this.state.otpError) && !this.props.newUI
                && <div className="alert alert-danger">
                    {this.props.error ? this.props.error : this.state.otpError}
                </div>}
                <div className="row text-center">
                    <div className="col-6">
                        {this.renderSendOtp()}
                    </div>
                    <div className="col-6">
                        {this.renderSubmitOtp()}
                    </div>
                </div>
            </form>
        </div>;
    }
}

